import gql from 'graphql-tag';

export const ITEM_FRAGMENT = gql`
  fragment ItemFragmentOnItem on Item {
    id
    defaultOrderStatus
    image {
      id
      file {
        id
        url
      }
    }
    titleLang {
      id
      se
      en
      es
      no
    }
    descriptionLang {
      id
      se
      en
      es
      no
    }
    courseType {
      id
      label
      color
      order
      name
    }
    volumeSuffix
    upsalesSortOrder
    upsales {
      id
      hideInPOS
      itemsSortingOrder
      name {
        id
        se
        en
        es
        no
      }
      items {
        id
        titleLang {
          id
          se
          en
          es
          no
        }
        defaultPrice
      }
    }
    modificationGroups
    manualName
  }
`;

export const OFFER_FRAGMENT = gql`
  fragment OfferFragment on Offer {
    id
    name

    type

    items(filter: { deleted: false }) {
      id
      title
    }

    stages {
      id
      title {
        id
        se
        en
        es
        no
      }

      items(filter: { deleted: false }) {
        id
        title
      }
    }
  }
`;
